import { render, staticRenderFns } from "./FabricDetails.vue?vue&type=template&id=544b99e8"
import script from "./FabricDetails.vue?vue&type=script&lang=js"
export * from "./FabricDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports